// List filters (companies, plans, markets, ...) are persisted in the browser, but they
// refer to things inside one organisation: a "Bundle: Flyjam" filter from one org hid every
// plan in the next. When the active organisation changes, every slice's `selectedFilters`
// goes back to that slice's own initial value; other saved preferences (columns, etc.) stay.
export const ORGANISATION_CHANGED = "app/organisationChanged";

export const organisationChanged = () => ({ type: ORGANISATION_CHANGED });

export const withOrgScopedFilterReset = (reducer) => {
  let initial;
  return (state, action) => {
    if (action.type === ORGANISATION_CHANGED && state) {
      initial = initial || reducer(undefined, { type: "@@orgScopedFilterReset/init" });
      const next = { ...state };
      Object.keys(initial).forEach((key) => {
        const slice = initial[key];
        if (slice && typeof slice === "object" && "selectedFilters" in slice && state[key]) {
          next[key] = { ...state[key], selectedFilters: slice.selectedFilters };
        }
      });
      return reducer(next, action);
    }
    return reducer(state, action);
  };
};
